import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import React, { useEffect } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router";
import styled from "styled-components";
// Highlight images
import Step1 from "../img/home/step-1@1x.png";
import Step1x2 from "../img/home/step-1@2x.png";
import Step2 from "../img/home/step-2@1x.png";
import Step2x2 from "../img/home/step-2@2x.png";
import Button from "./Button";
import { Main, Wrapper } from "./Layout";
import Login from "./Login";
import Status from "./status/Status";
import TriangleCard from "./TriangleCard";

const Highlights = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};
  margin: ${({ theme }) => theme.space[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin-inline-start: ${({ theme }) => theme.space[4]};
    margin-inline-end: ${({ theme }) => theme.space[4]};
  }
`;

//<Button> was overriding 'flex: 1' on the flex items - this corrects that
const HighlightsFlexItem = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 0 0 calc(50% - 1rem);
  }
`;

const HighlightsItem = styled.div`
  width: 100%;
  height: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex: 0 0 calc(50% - 1rem);
    margin-bottom: 0;
  }
`;

type Props = WithTranslation;

const Home: React.FC<Props> = ({ t }) => {
  const now = useSelector(getCurrentEvent);
  const player = useSelector(getPlayerData);

  const TrackFacebook = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq("trackCustom", "FPLLanding");
    }
  };

  useEffect(() => {
    TrackFacebook();
  }, []);

  if (now && player && player.entry) {
    return <Status />;
  }

  return (
    <Wrapper>
      <Main isWide={true}>
        <Login />
        <Highlights>
          {player && !player.entry && (
            <>
              <HighlightsFlexItem>
                <Button to="/squad-selection" variant="home" as={Link}>
                  <HighlightsItem>
                    <TriangleCard
                      title={t("home.highlightsLeftTitle", "Pick your squad")}
                      desc={t(
                        "home.highlightsLeftDesc",
                        "Use your budget of €100M to pick a squad of 15 players from Liga Portugal.",
                      )}
                      mdSrc={Step1x2}
                      smSrc={Step1}
                    />
                  </HighlightsItem>
                </Button>
              </HighlightsFlexItem>

              <HighlightsFlexItem>
                <Button to="/squad-selection" variant="home" as={Link}>
                  <HighlightsItem>
                    <TriangleCard
                      title={t(
                        "home.highlightsRightTitle",
                        "Create & join leagues",
                      )}
                      desc={t(
                        "home.highlightsRightDesc",
                        "Play against friends, family members, colleagues or your friends from the web in private leagues.",
                      )}
                      mdSrc={Step2x2}
                      smSrc={Step2}
                    />
                  </HighlightsItem>
                </Button>
              </HighlightsFlexItem>
            </>
          )}

          {player && player.entry && (
            <>
              <HighlightsFlexItem>
                <Button to="/transfers" variant="home" as={Link}>
                  <HighlightsItem>
                    <TriangleCard
                      title={t("home.highlightsLeftTitle", "Pick your squad")}
                      desc={t(
                        "home.highlightsLeftDesc",
                        "Use your budget of 100M EURO to pick a squad of 15 players from Liga Portugal.",
                      )}
                      mdSrc={Step1x2}
                      smSrc={Step1}
                    />
                  </HighlightsItem>
                </Button>
              </HighlightsFlexItem>

              <HighlightsFlexItem>
                <Button to="/leagues" variant="home" as={Link}>
                  <HighlightsItem>
                    <TriangleCard
                      title={t(
                        "home.highlightsRightTitle",
                        "Create & join leagues",
                      )}
                      desc={t(
                        "home.highlightsRightDesc",
                        "Play against friends, family members, colleagues or your friends from the web in private leagues.",
                      )}
                      mdSrc={Step2x2}
                      smSrc={Step2}
                    />
                  </HighlightsItem>
                </Button>
              </HighlightsFlexItem>
            </>
          )}

          {!player && (
            <>
              <HighlightsItem>
                <TriangleCard
                  title={t("home.highlightsLeftTitle", "Pick your squad")}
                  desc={t(
                    "home.highlightsLeftDesc",
                    "Use your budget of 100M EURO to pick a squad of 15 players from Liga Portugal.",
                  )}
                  mdSrc={Step1x2}
                  smSrc={Step1}
                />
              </HighlightsItem>

              <HighlightsItem>
                <TriangleCard
                  title={t(
                    "home.highlightsRightTitle",
                    "Create & join leagues",
                  )}
                  desc={t(
                    "home.highlightsRightDesc",
                    "Play against friends, family members, colleagues or your friends from the web in private leagues.",
                  )}
                  mdSrc={Step2x2}
                  smSrc={Step2}
                />
              </HighlightsItem>
            </>
          )}
        </Highlights>
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(Home);
